import React from "react"
import { graphql } from "gatsby"

import BookList from "../components/bookList"

class Home extends React.Component {
  render() {
    const { data } = this.props
    const books = data.allContentfulBook.edges
    return <BookList books={books} />
  }
}

export default Home

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulBook {
      edges {
        node {
          title
          author
          url
          image {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`
